// extracted by mini-css-extract-plugin
export var standaloneTable = "_g9-0";
export var standaloneTableWithBodyFill = "_g9-1";
export var withExtraHeader = "_g9-2";